<div class="page-loader" [class.d-loader-none]="!showLoader" [class.hideLoaderBlurBackground]="!showLoaderBlurBackground">
  <lottie-player src="/assets/loader.json" background="transparent"  speed="1" class="lottie-loader"  loop autoplay #fooPageLoader></lottie-player>
</div>
